import React, { useContext, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import commentContext from "../../contextApi";

import { removeComment, loadDetailPost } from "redux/modules/postSlice";

import LikeToggleComment from "../../../common/LikeToggleComment/index";

import { DeleteModal, ConfirmMsg } from "../../../MoreComponent";

import { PostInfo, DetailContent, DetailAside } from "../../DetailPostStyle";
import { CommentMoreContainer } from "./style";

function CommentRenderTwo({ post, comment, render, textareaRef }) {
  const dispatch = useDispatch();
  const { commentMore, setVisiblePropsFunc, setCommentMorePropsFunc } =
    useContext(commentContext);

  // 1: 일반유저, 0: 관리자
  const isLevel = window.localStorage.getItem("level");

  const myNickName = window.localStorage.getItem("nickname");
  const commentAuthor = comment?.nickname;
  const commentIsMe = myNickName === commentAuthor;

  const [commentMoreId, setCommentMoreId] = useState(""); // 더보기 클릭된 댓글Id
  const [commentModalToggle, setCommentModalToggle] = useState(false); // 더보기-삭제누를시 나오는토글
  const [commentDeleteMsgToggle, setCommentDeleteMsgToggle] = useState(false); // 더보기-삭제됨 알림

  // 더보기버튼 클릭
  const onClickCommentsMore = useCallback(
    (e) => {
      setCommentMoreId(e.target.id);
      setCommentMorePropsFunc();
    },
    [setCommentMorePropsFunc],
  );

  // 댓글 수정 입력창
  const onClickCommentUpdate = useCallback(() => {
    setVisiblePropsFunc();
  }, [setVisiblePropsFunc]);

  // 댓글 삭제
  const onClickCommentRemove = useCallback(() => {
    setCommentMorePropsFunc();
    setCommentModalToggle(true);
  }, [setCommentMorePropsFunc]);

  // 삭제 - props전달할것들
  const query = "댓글을 삭제하시겠습니까?";
  const notice = "삭제한 댓글은 복구할 수 없습니다.";
  const afterConfirm = "댓글이 삭제되었습니다";
  const onClickCancel = () => {
    setCommentModalToggle(false);
  };
  const onClickConfirm = () => {
    setCommentModalToggle(false);
    setCommentDeleteMsgToggle(true);
    const payload = {
      boardId: post.boardId,
      commentId: comment.commentId,
    };
    dispatch(removeComment(payload));

    setTimeout(() => {
      setCommentDeleteMsgToggle(false);
      dispatch(loadDetailPost(post.boardId));
    }, 700);
  };

  // 좋아요관련
  const [like, setLike] = useState(comment?.likeCount);

  const likeCountFunc = (v) => {
    setLike(v);
  };

  // content url입력시 자동링크 함수
  function urlify(text) {
    const urlReg = /(https?:\/\/[^\s]+)/g;
    return text?.replace(urlReg, function (url) {
      return (
        '<a href="' +
        url +
        '" target="_blank" rel="noopener noreferrer">' +
        url +
        "</a>"
      );
    });
  }

  const onClickTextArea = () => {
    textareaRef.current.focus();
  };

  return (
    <>
      <PostInfo>
        <div className="profileInfo">
          <img
            className="profileImg"
            referrerPolicy="no-referrer"
            src={comment?.profileImage}
            alt="account circle"
          />
          <div className="nickAndCreateAt">
            <div className="detail-nickname">{comment?.nickname}</div>
            <div className="detail-createAt">{comment?.createdDate}</div>
          </div>
        </div>
        <img
          className="more"
          id={comment?.commentId}
          src="/img/moreGray.svg"
          alt="arrow back"
          onClick={onClickCommentsMore}
        />
      </PostInfo>

      {/* 수정,삭제 / 신고 */}
      {commentMore && parseInt(commentMoreId) === comment.commentId && (
        <CommentMoreContainer>
          {isLevel === "0" ? ( // 관리자여부
            <div>
              <div onClick={onClickCommentRemove}>삭제</div>
            </div>
          ) : commentIsMe === true ? (
            <div>
              <div onClick={onClickCommentUpdate}>수정</div>
              <div onClick={onClickCommentRemove}>삭제</div>
            </div>
          ) : (
            <div>
              <Link
                to={`/boards/${post.boardId}/comments/${comment.commentId}/report`}
                state={{
                  commentId: comment.commentId,
                }}
              >
                <div>댓글 신고</div>
              </Link>
            </div>
          )}
        </CommentMoreContainer>
      )}

      <DetailContent>
        <div
          dangerouslySetInnerHTML={{ __html: urlify(comment?.content) }}
        ></div>
      </DetailContent>

      <DetailAside>
        <div className="detail-liked">
          <LikeToggleComment
            postId={post.boardId}
            commentId={comment?.commentId}
            likeCountFunc={likeCountFunc}
          />
          <span>좋아요</span>
          <span>{like}</span>
        </div>
        {render === "CommentsRender" ? ( // 답글쓰기 페이지
          <div className="detail-comments">
            <img src="/img/comment.svg" alt="답글" />
            <span onClick={onClickTextArea}>답글쓰기</span>
          </div>
        ) : (
          // 게시글 상세페이지
          <div className="detail-comments">
            <img src="/img/comment.svg" alt="답글" />
            <Link
              to={`/boards/${post.boardId}/comments/${comment.commentId}`}
              state={{
                postId: post.boardId,
                commentId: comment.commentId,
              }}
            >
              <span>답글쓰기</span>
            </Link>
          </div>
        )}
      </DetailAside>

      {/* 삭제관련 토글 */}
      {commentModalToggle && (
        <DeleteModal
          query={query}
          notice={notice}
          onClickCancel={onClickCancel}
          onClickConfirm={onClickConfirm}
        />
      )}
      {/* 삭제됨 알림 */}
      {commentDeleteMsgToggle && <ConfirmMsg afterConfirm={afterConfirm} />}
    </>
  );
}

export default CommentRenderTwo;
